/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext, useState, useEffect } from 'react';
import { Col, Collapse, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from './ErrorBoundary';
import GeneralNavbar from './GeneralNavbar';
import Footer from './Footer';
import './generalPages.css'

const FAQ = props => {

    // contexts
    const { theme, fontWeight } = useContext(ThemeContext);

    // states
    // const [isOpen, setIsOpen] = useState([false, false, false, false, false, false, false, false, false]);
    const [activeTab, setActiveTab] = useState("client");
    const [FAQ, setFAQ] = useState({
        client: [
            // {
            //     question: 'What is Umang Wellness?',
            //     answer: `Umang Wellness is an online counselling service that allows you to talk to an expert psychologist in a safe and confidential way. We help people by getting them to face life's challenges by providing convenient, discreet and affordable access to a qualified counsellor.`,
            // }, {
            //     question: 'How are the sessions delivered?',
            //     answer: `You’ll enjoy connecting with your psychologist via chat, voice call, or video using your phone, tablet or computer from the comfort and privacy of your home or whatever place you choose.`,
            // }, {
            //     question: 'What are the focus markets?',
            //     answer: `Umang Wellness current focus is helping people with origins in South Asia. Presently the service is only available if you reside in India.`,
            // }, {
            //     question: 'How can Umang Wellness help me?',
            //     answer: `Counselling from Umang Wellness may be able to help you if you're looking to improve the quality of your life. If there are issues in your life that prevent you from enjoying life and being happy, or from achieving your goals in life, or from who you want to be, we may be able to help you.`,
            // }, {
            //     question: 'Which areas can I get help with?',
            //     answer: `Umang Wellness counsellors are specialized in specific issues such as stress, anxiety, relationships, parenting, depression, addictions, eating, sleeping, trauma, anger, family conflicts, LGBT matters, grief, religion, self esteem and more.`,
            // }, {
            //     question: 'When may Umang Wellness not help me?',
            //     answer: <div>Umang Wellness will not take cases when:<ul className="mt-1">
            //         <li>You have thoughts of hurting yourself or others.</li>
            //         <li>You are facing an urgent crisis or an emergency situation.</li>
            //         <li>You have been diagnosed with a severe mental illness.</li>
            //         <li>You have been advised to be in psychological supervision or psychiatric care.</li>
            //         <li>You were required to undergo therapy or counseling either by a court order or by any other authority.</li>
            //         <li>You do not have a device that can connect to the Internet or you do not have a reliable Internet connection.</li>
            //         <li>You are a minor who wants to get counselling without your parent’s or legal guardian’s consent.</li>
            //     </ul></div>,
            // }, {
            //     question: 'How can a Umang Wellness psychologist solve my problems?',
            //     answer: `Psychologists are trained to help people with issues of the mind. They play a major role by diagnosing and treating people who have psychological problems related to physical and mental health. Psychological counselling is the recommended treatment plan if one faces such issues.`,
            // }, {
            //     question: 'How does Umang Wellness keep my sessions private and confidential?',
            //     answer: `Whatever you tell your psychologist will remain with that psychologist only. The data is not recorded on Umang Wellness site. Our well-defined processes are designed to keep the contents of sessions highly confidential.`,
            // }, {
            //     question: 'Will my medical doctor or professional be contacted?',
            //     answer: `If the situation demands where we will need to get some information from your medical doctor or professional as part of your therapy, we will explicitly ask for your consent to get such information.`,
            // }
        ],
        counsellor: [
            // {
            //     question: 'Why should I sign up as a counsellor on Umang Wellness?',
            //     answer: <ul className="mt-1">
            //         <li>A modern platform that you can use to connect with your clients.</li>
            //         <li>Manage everything about your practice.</li>
            //         <li>Your own homepage for your clients to find and know you - No need to set up your own website.</li>
            //         <li>Clients may book sessions and/or subscribe to counselling on an on-going basis.</li>
            //         <li>Clients enrolled in subscription plans may chat with you 24x7 Book session on behalf of a client.</li>
            //         <li>You keep what you make, no commissions on what you charge from your clients.</li>
            //         <li>Free technical support.</li>
            //         <li>List your other services.</li>
            //     </ul>
            // }, {
            //     question: 'How may I join as a counsellor on Umang Wellness?',
            //     answer: <div>Here is the process:<ul className='mt-1'>
            //         <li>Scroll to the bottom of the home page.</li>
            //         <li>Under the User section, click on Become Counsellor.</li>
            //         <li>Review the pricing plans.</li>
            //         <li>Select a pricing plan. You will be enrolled into the FREE plan by default if you proceed to sign up.</li>
            //         <li>Sign up by providing your first and last name, email id, username and password of your choice.</li>
            //         <li>An email will be sent to the email ID provided by you.</li>
            //         <li>Verify your email by clicking a link that was sent to you in the email you received.</li>
            //         <li>Once you sign in, set up your profile page and other details like your availability, your pricing, subscription plans for clients, etc.</li>
            //         <li>For help contact at the email ID: support@umangwellness.com</li>
            //     </ul>
            //     </div>
            // }, {
            //     question: 'How much does it cost to become a counsellor?',
            //     answer: 'Please see the pricing plans at https://umangwellness.com/pricing'
            // }
        ]
    });

    //scroll to top
    useEffect(() => {
        window.scrollTo(0, 0);
        GeneralService.getFAQs().then(data => {
            setFAQ(data.faqs);
            // console.log("data", data);
        })
    }, []);

    // utility functions
    const createMarkup = (html) => {
        return { __html: html };
    }

    const toggle = (type, index) => {
        try {
            const tempArray = [...FAQ[type]];
            tempArray[index].isOpen = !tempArray[index].isOpen;
            setFAQ({ ...FAQ, [type]: tempArray });
            // setIsOpen({ ...isOpen, [index]: !isOpen[index] })
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at General FAQ toggle', 'Error in try catch block', err.stack);
        }
    };

    // function's return
    return (
        <div className="faqMainDiv">
            <ErrorBoundary errorAt="At General FAQ GeneralNavbar">
                <GeneralNavbar history={props.history} isFAQPage={true} />
            </ErrorBoundary>
            <div className="custom-header">
                <h3 id="faq-heading" >Frequently Asked Questions</h3>
            </div>
            <Nav justified tabs className='mt-4 mx-3'>
                <NavItem style={{ fontSize: "1.2rem", fontWeight: "600", cursor: "pointer" }}>
                    <NavLink
                        style={{ borderWidth: "medium" }}
                        active={activeTab === "client"}
                        onClick={() => setActiveTab("client")}
                    >
                        For Clients
                    </NavLink>
                </NavItem>
                <NavItem style={{ fontSize: "1.2rem", fontWeight: "600", cursor: "pointer" }}>
                    <NavLink
                        style={{ borderWidth: "medium" }}
                        active={activeTab === "counsellor"}
                        onClick={() => setActiveTab("counsellor")}
                    >
                        For Counsellors
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="client">
                    {
                        FAQ.client.map((item, index) => (
                            <div className="p-3 m-3" style={theme.card}>
                                <div id="faq-item-heading" className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle("client", index)}>
                                    <span style={theme.headingBold}>{item.question}</span>
                                    {
                                        item.isOpen
                                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                                    }

                                </div>

                                <Collapse isOpen={item.isOpen}>
                                    <hr />
                                    <div className="my-auto" style={theme.paragraph} dangerouslySetInnerHTML={createMarkup(item.answer)}></div>
                                </Collapse>
                            </div>
                        ))
                    }
                </TabPane>
                <TabPane tabId="counsellor">
                    {
                        FAQ.counsellor.map((item, index) => (
                            <div className="p-3 m-3" style={theme.card}>
                                <div id="faq-item-heading" className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle("counsellor", index)}>
                                    <span style={theme.headingBold}>{item.question}</span>
                                    {
                                        item.isOpen
                                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                                    }

                                </div>

                                <Collapse isOpen={item.isOpen}>
                                    <hr />
                                    <div className="my-auto" style={theme.paragraph} dangerouslySetInnerHTML={createMarkup(item.answer)}></div>
                                </Collapse>
                            </div>
                        ))
                    }
                </TabPane>
            </TabContent>
            <Footer />
        </div >
    )

}

export default FAQ;